var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('video',{ref:"video",staticClass:"video-player",attrs:{"autoplay":"","muted":"","loop":"","src":_vm.currentVideo},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }